import { post, get, postAsync } from 'utils/fetch';
import {
    CreateUpBalanceLinkProps,
    CreateUpBalanceLinkResult,
    CreateAssignPaymentResult
} from './money.types';
import { RouterPaths } from 'helpers/router-paths';

export const createUpBalanceLink = (balanceId: number, amount: number) =>
    post<unknown, CreateUpBalanceLinkResult, CreateUpBalanceLinkProps>(
        'Payment/Balance',
        {
            balanceId,
            amount,
            returnUrl: window.location.href
        }
    );

export const getAssignPayLink = (id: number, returnUrl?: string) =>
    get<CreateAssignPaymentResult>(`Payment/Assign/${id}`, {
        returnUrl: returnUrl ?? RouterPaths.CourseAssignment(id)
    });

export const payAssignFromBalance = (
    organizationId: number,
    assignId: number
) =>
    postAsync<{ ok: boolean }>(
        `Payment/AssignFromBalanceOrg/${organizationId}/${assignId}`,
        {}
    );
